import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  KibCheckbox,
  type KibCheckboxModelValue,
} from '@chewy/kib-choices-react'
import { KibFilterIcon } from '@chewy/kib-icons-react'
import { KibGrid } from '@chewy/kib-layout-react'

import KibIconButtonWithMenu from '~/components/common/buttons/KibIconButtonWithMenu'
import { setConversationsListFilters } from '~/store/actions/conversations'
import { getConversationsListFilters } from '~/store/reducers/conversations'
import type { TableFilter } from '~/types'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-controls-styles/dist/styles/kib-toggle.css'
import '@chewy/kib-transition-styles/dist/kib-transition.css'
import '@chewy/kib-layout-styles/dist/styles/kib-grid.css'
import styles from './CommunicationFilter.module.scss'

const CommunicationFilter = () => {
  const { t } = useTranslation(['Common', 'Clients'])
  const dispatch = useDispatch()
  const filters = useSelector(getConversationsListFilters)

  const setFilters = (newFilters: Record<string, TableFilter>) => {
    dispatch(setConversationsListFilters(newFilters))
  }

  const dropdownFilters = [
    {
      active: !filters.excludeSystemMessages?.value,
      text: t('Common:SHOW_SYSTEM_MESSAGES'),
      onClick: (checked: KibCheckboxModelValue) => {
        setFilters({
          ...filters,
          excludeSystemMessages: {
            value: !checked,
          },
        })
      },
      id: 'system-message-filter',
    },
  ]

  return (
    <KibIconButtonWithMenu
      ariaLabel={t('Clients:COMMUNICATION_WIDGET.OPEN_FILTER_DROPDOWN')}
      ariaLabelSelected={t(
        'Clients:COMMUNICATION_WIDGET.CLOSE_FILTER_DROPDOWN',
      )}
      className={styles.filterButton}
      emphasis="tertiary"
      icon={<KibFilterIcon />}
      openClassName={styles.filterOpen}
      size="medium"
      theme="utility"
    >
      <div>
        <KibGrid className={styles.optionCount}>
          {t('Clients:COMMUNICATION_WIDGET.AVAILABLE_OPTIONS', {
            numOptions: dropdownFilters.length,
          })}
        </KibGrid>
        {dropdownFilters.map(({ id, onClick, active, text }) => (
          <KibCheckbox
            className={styles.filterItem}
            key={id}
            label={text}
            role="menuitemcheckbox"
            selectedValue={active}
            onChange={onClick}
          />
        ))}
      </div>
    </KibIconButtonWithMenu>
  )
}

export default CommunicationFilter
